import { FormLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledLabelFieldDiv = styled.div`
    display: flex;
    flex-direction: column;
`;

const LTIVersionDiv = styled.div`
    margin-top: 24px;
    display: flex;
`;

interface LTIVersionProps {
    ltiVersion: string;
}

const LTIVersionText: React.FC<LTIVersionProps> = ({ ltiVersion }) => {
    const { t } = useTranslation('admin_settings');
    return (
        <LTIVersionDiv>
            <StyledLabelFieldDiv>
                <Typography>{t('lti-type')}</Typography>
                <FormLabel>{`LTI ${ltiVersion}`}</FormLabel>
            </StyledLabelFieldDiv>
        </LTIVersionDiv>
    );
};

export default LTIVersionText;
